import { Cascader, Modal, Radio, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { optionsList } from '../index.jsx';
import { ReactComponent as DeleteSvg } from '../../../assets/svgs/delete.svg';
import SvgCom from '../../../components/SvgCom/index.jsx';
import {ReactComponent as CloseSvg} from '../../../assets/svgs/close.svg';

const classNames = {
  content: '!p-[18px]',
};

const FilterWinCom = ({openWin, optionValueList, onValueChange, onClose}) => {
  const [filterList, setFilterList] = useState([]);
  const [logic, setLogic] = useState('and');

  const fnAddNewFilter = () => {
    const tempFilterList = [...filterList];
    const newFilter = {
      field: null,
      operator: null,
      value: null,
    };
    tempFilterList.push(newFilter);
    setFilterList(tempFilterList);
  };

  const fnDelFilter = (index) => {
    const tempFilterList = [...filterList];
    tempFilterList.splice(index, 1);
    setFilterList(tempFilterList);
  };

  const setAttrValue = (index, field, value) => {
    const tempFilterList = [...filterList];
    tempFilterList[index][field] = value;
    setFilterList(tempFilterList);
  };

  const fnReset = () => {
    setFilterList([
      {
        field: null,
        operator: null,
        value: null,
      }
    ]);
  };

  const fnAfterClose = () => {
    // setFilterList([]);
  };

  const fnApply = () => {
    let tempFilterList = [...filterList];
    tempFilterList = tempFilterList.filter(item => item.field && item.operator && item.value);
    tempFilterList = tempFilterList.map(item => {
      if(item.field === 'geographic') {
        item.value = item.value[item.value.length - 1];
      }
      return item;
    });
    onValueChange({
      logic,
      children: tempFilterList
    });
    onClose(false);
  };

  useEffect(()=> {
    if(openWin) {
      if(filterList.length <= 0) {
        fnAddNewFilter();
      }
    }
  }, [openWin, filterList]);

  return (
    <>
      {/* destroyOnClose */}
      <Modal open={openWin} afterClose={fnAfterClose} onCancel={() => onClose(false)} closeIcon={<SvgCom Svg={CloseSvg} size='20'></SvgCom>} footer={null} centered={true} classNames={classNames}>
        <div className=''>
          <div className='text-[14px] font-semibold leading-none mb-5'>Advance Filter</div>
          <Radio.Group
            value={logic}
            onChange={(e) => setLogic(e.target.value)}
            defaultValue={'and'}
            className='radio_box ml-2 mb-1'
            options={[
              { value: 'and', label: 'And' },
              { value: 'or', label: 'Or' },
            ]}
          />
          {
            filterList.map((item, index) => <div key={index} className='bg-[#F5F8F6] px-[10px] py-[7px] flex items-center justify-start'>
              <Select
                allowClear
                style={{ width: 120 }}
                value={filterList[index]['field']}
                onChange={(value) => setAttrValue(index, 'field', value)}
                placeholder="Please select field"
                className=''
                options={optionsList}
              />
              <Select
                allowClear
                style={{ width: 120 }}
                value={filterList[index]['operator']}
                onChange={(value) => setAttrValue(index, 'operator', value)}
                placeholder="Operator"
                className='mx-2'
                options={[
                  {label: 'Equal To', value: 'eq'},
                  {label: 'Not Equal To', value: 'neq'},
                  // {label: 'And', value: 'and'},
                  // {label: 'Or', value: 'or'},
                  {label: 'Like', value: 'like'},
                  {label: 'ILike', value: 'ilike'},
                  {label: 'In', value: 'in'},
                  {label: 'Great Then', value: 'gt'},
                  {label: 'Great Then Or Equal', value: 'gte'},
                  {label: 'Less Then', value: 'lt'},
                  {label: 'Less Then Or Equal', value: 'lte'},
                ]}
              />
              {
                filterList[index]['field'] === 'geographic' ?  <Cascader value={filterList[index]['value']} allowClear onChange={(value) => setAttrValue(index, 'value', value)} className='flex-1' options={optionValueList[filterList[index]['field']] || []} placeholder="Please select value" />  : 
                  <Select
                    allowClear
                    style={{ width: 120 }}
                    value={filterList[index]['value']}
                    onChange={(value) => setAttrValue(index, 'value', value)}
                    placeholder="Please select value"
                    className='flex-1'
                    options={optionValueList[filterList[index]['field']]}
                  />
              }
              
              <SvgCom onClick={() => fnDelFilter(index)} Svg={DeleteSvg} size="22" className="ml-2 cursor-pointer hover:text-green-1 text-primary"></SvgCom>
            </div>)
          }
          
          <div className='flex items-center justify-between mt-5'>
            <button onClick={fnAddNewFilter} className='border rounded-[20px] px-3 py-1 border-primary text-primary text-[14px] hover:bg-second'>Add Filter</button>
            <div className='flex items-center'>
              <button onClick={fnReset} className='border rounded-[20px] px-3 py-1 text-primary text-[14px] bg-second mr-2'>Reset</button>
              <button onClick={fnApply} className='border rounded-[20px] px-3 py-1 text-white text-[14px] bg-primary'>Apply</button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FilterWinCom;